module.exports = __webpack_public_path__ + "img/20191002_113209.98f5e605.jpg";